import { css } from '@emotion/react'

export const copyButton = css`
  margin-left: 10px;
  background: #0074d3;
  border-radius: 0 4px 4px 0;
`

export const textfieldWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
`

export const shareDialog = css`
  min-width: 600px;
  min-height: 457px;
`
